import React, { Fragment } from 'react';
import { TROUBLESHOOTING_LINK_STUDENTS } from 'legacy/src/constants/config';

const PLATFORMS = {
  Win: SECURE_BROWSER_LINK_WINDOWS,
  Mac: SECURE_BROWSER_LINK_MACOSX,
  iPad: SECURE_BROWSER_LINK_IOS,
};

const isIpad = () => {
  const { platform, maxTouchPoints } = navigator;
  return platform === 'iPad' || (platform === 'MacIntel' && maxTouchPoints > 0);
};

const getDownloadURL = () => {
  let url = null;
  Object.keys(PLATFORMS).forEach((platform) => {
    if (navigator.platform.indexOf(platform) > -1) {
      url = isIpad()
        ? PLATFORMS.iPad
        : `${FYM_FRONTEND_URL}/${PLATFORMS[platform]}`;
    }
  });
  return url;
};

const SecureBrowserBanner = ({
  readinessCheckURL,
  openReadinessCheck,
  ipadLdbMessageFlag,
}) => {
  const downloadURL = getDownloadURL();

  const showIpadMessage = ipadLdbMessageFlag && isIpad();

  const bannerStyles =
    'bg-blue-100 border border-blue-500 p-8 rounded-md leading-10 mb-12';

  const linkStyles = 'hover:underline';

  return [
    showIpadMessage && (
      <div className={bannerStyles} key="ipad-message">
        <strong>Attention iPad users:</strong> Please download the new and
        improved LockDown Browser app{' '}
        <a
          href="https://itunes.apple.com/ca/app/lockdown-browser/id659101775?mt=8"
          target="_blank"
          className={linkStyles}
          rel="noopener noreferrer"
        >
          here
        </a>
        . This is required, as iPads will no longer work with other LockDown
        Browser versions as of January 31. If you open the{' '}
        <a
          onClick={() => openReadinessCheck(readinessCheckURL)}
          role="link"
          className={linkStyles}
          tabIndex="0"
        >
          readiness check
        </a>{' '}
        and do not see an ‘Update Available’ notification, then you already have
        the new version and no action is required.
      </div>
    ),
    <div className={bannerStyles} key="readiness-check-message">
      <strong>Secure Assignment Readiness Check:</strong> You&apos;ve been
      assigned a secure assessment using the LockDown Browser. Before your
      assignment start date, you’ll need the LockDown Browser installed on your
      device.{' '}
      <a
        onClick={() => openReadinessCheck(readinessCheckURL)}
        role="link"
        className={linkStyles}
        tabIndex="0"
      >
        Please complete this readiness check
      </a>{' '}
      to confirm successful installation.&nbsp;
      {downloadURL && (
        <Fragment>
          <strong>
            If the readiness check doesn’t open, this means the LockDown Browser
            still needs to be installed.
          </strong>{' '}
          Download it{' '}
          <a className={linkStyles} href={downloadURL}>
            here
          </a>{' '}
          and use this{' '}
          <a
            href={TROUBLESHOOTING_LINK_STUDENTS}
            target="_blank"
            className={linkStyles}
            rel="noopener noreferrer"
          >
            troubleshooting guide
          </a>{' '}
          with your teacher if you have any issues.
        </Fragment>
      )}
    </div>,
  ];
};

export default SecureBrowserBanner;
